import { render, staticRenderFns } from "./CampaignInfoList.vue?vue&type=template&id=a2a1c4ba"
import script from "./CampaignInfoList.vue?vue&type=script&lang=js"
export * from "./CampaignInfoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports